import React from 'react'
import './families-to-watch.css'

const FamiliesToWatch = (props) => {

    const [waitCount, setWaitCount] = React.useState({MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0})
    const [summerCount, setSummerCount] = React.useState({MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0})
    const [needsCount, setNeedsCount] = React.useState({MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0})
    const [attentionCount, setAttentionCount] = React.useState({MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0})
    const listOfSchools = ['MMA', 'LSMA', 'TMA', 'MOR', 'PSMA']

    React.useEffect(() => {
        let myWaitCount = { MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0}
        let mySummerCount = { MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0}
        let myNeedsCount = { MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0}
        let myAttentionCount = { MAIN: 0, MMA: 0, LSMA: 0, TMA: 0, MOR: 0, PSMA: 0}

        for(let i = 0; i < props.familiesToWatch.length; i++) {
            if(props.familiesToWatch[i].familyStatus === 'Waitlist') {
                myWaitCount['MAIN'] = myWaitCount['MAIN']+ 1
                for(let j = 0; j < listOfSchools.length; j++) {
                    if(props.familiesToWatch[i].school === listOfSchools[j]) {
                        myWaitCount[listOfSchools[j]] = myWaitCount[listOfSchools[j]] + 1
                    }
                }
            }
            if(props.familiesToWatch[i].familyStatus === 'Taking a Break') {
                mySummerCount['MAIN'] = mySummerCount['MAIN']+ 1
                for(let j = 0; j < listOfSchools.length; j++) {
                    if(props.familiesToWatch[i].school === listOfSchools[j]) {
                        mySummerCount[listOfSchools[j]] = mySummerCount[listOfSchools[j]] + 1
                    }
                }
            }
            if(props.familiesToWatch[i].familyStatus === 'Needs New Teacher') {
                myNeedsCount['MAIN'] = myNeedsCount['MAIN']+ 1
                for(let j = 0; j < listOfSchools.length; j++) {
                    if(props.familiesToWatch[i].school === listOfSchools[j]) {
                        myNeedsCount[listOfSchools[j]] = myNeedsCount[listOfSchools[j]] + 1
                    }
                }
            }
        }
        for(let i = 0; i < props.familiesToWatch.length; i++) {
            for(let j = 0; j < props.familiesToWatch[i].students.length; j++) {
                if(props.familiesToWatch[i].students[j].studentStatus === 'Waitlist' && props.familiesToWatch[i].familyStatus !== 'Waitlist') {
                    myWaitCount['MAIN'] = myWaitCount['MAIN']+ 1
                    for(let j = 0; j < listOfSchools.length; j++) {
                        if(props.familiesToWatch[i].school === listOfSchools[j]) {
                            myWaitCount[listOfSchools[j]] = myWaitCount[listOfSchools[j]] + 1
                        }
                    }
                } else if (props.familiesToWatch[i].students[j].studentStatus === 'Taking a Break' && props.familiesToWatch[i].familyStatus !== 'Taking a Break') {
                    mySummerCount['MAIN'] = mySummerCount['MAIN']+ 1
                    for(let j = 0; j < listOfSchools.length; j++) {
                        if(props.familiesToWatch[i].school === listOfSchools[j]) {
                            mySummerCount[listOfSchools[j]] = mySummerCount[listOfSchools[j]] + 1
                        }
                    }
                } else if (props.familiesToWatch[i].students[j].studentStatus === 'Needs New Teacher' && props.familiesToWatch[i].familyStatus !== 'Needs New Teacher') {
                    myNeedsCount['MAIN'] = myNeedsCount['MAIN']+ 1
                    for(let j = 0; j < listOfSchools.length; j++) {
                        if(props.familiesToWatch[i].school === listOfSchools[j]) {
                            myNeedsCount[listOfSchools[j]] = myNeedsCount[listOfSchools[j]] + 1
                        }
                    }
                }
            }
        }

        for(let i = 0; i < props.moreAttentionFamilies.length; i++) {
            myAttentionCount['MAIN'] = myAttentionCount['MAIN']+ 1
            for(let j = 0; j < listOfSchools.length; j++) {
                if(props.moreAttentionFamilies[i].school === listOfSchools[j]) {
                    myAttentionCount[listOfSchools[j]] = myAttentionCount[listOfSchools[j]] + 1
                }
            }
        }
        setAttentionCount(myAttentionCount)
        setWaitCount(myWaitCount)
        setSummerCount(mySummerCount)
        setNeedsCount(myNeedsCount)
    })

    const toggleDrawAnimation = (list, school) => {
        document.getElementById(`families-to-watch__${list}-${school}`).style.height === '0px' || document.getElementById(`families-to-watch__${list}-${school}`).style.height === '' ? document.getElementById(`families-to-watch__${list}-${school}`).style.height = 'auto' : document.getElementById(`families-to-watch__${list}-${school}`).style.height = '0px'
        document.getElementById(`families-to-watch__${list}-${school}`).style.height === '0px' || document.getElementById(`families-to-watch__${list}-${school}`).style.height === '' ? document.getElementById(`families-to-watch__wrapper__${list}-${school}`).style.backgroundColor = 'rgba(240, 240, 240, 0.8)' : document.getElementById(`families-to-watch__wrapper__${list}-${school}`).style.backgroundColor = '#fff'
    }

    return(
        <div className='families-to-watch'>
            <div className='families-to-watch-col'>
                <h1>More Attention</h1><p className='families-to-watch-col__count'>{attentionCount['MAIN']}</p>
                <div className='families-to-watch-col__scroll-area'>
                    {listOfSchools.map(singleSchoolAbbr => (
                        <div key={singleSchoolAbbr} className='families-to-watch__school-flip-down__wrapper' id={`families-to-watch__wrapper__attention-${singleSchoolAbbr}`}>
                            <h3 onClick={() => toggleDrawAnimation('attention', singleSchoolAbbr)}>{singleSchoolAbbr}</h3>{attentionCount[singleSchoolAbbr] > 0 && <p className='families-to-watch-col__count__small'>{attentionCount[singleSchoolAbbr]}</p>}
                            <div className='families-to-watch__school-flip-down' id={`families-to-watch__attention-${singleSchoolAbbr}`}>
                                {props.moreAttentionFamilies.map(fam => (
                                    fam.moreAttention && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={fam.familyId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='families-to-watch-col'>
                <h1>Waitlist</h1><p className='families-to-watch-col__count'>{waitCount['MAIN']}</p>
                <div className='families-to-watch-col__scroll-area'>
                    {listOfSchools.map(singleSchoolAbbr => (
                        <div key={singleSchoolAbbr} className='families-to-watch__school-flip-down__wrapper' id={`families-to-watch__wrapper__waitlist-${singleSchoolAbbr}`}>
                            <h3 onClick={() => toggleDrawAnimation('waitlist', singleSchoolAbbr)}>{singleSchoolAbbr}</h3>{waitCount[singleSchoolAbbr] > 0 && <p className='families-to-watch-col__count__small'>{waitCount[singleSchoolAbbr]}</p>}
                            <div className='families-to-watch__school-flip-down' id={`families-to-watch__waitlist-${singleSchoolAbbr}`}>
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus === 'Waitlist' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={fam.familyId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                ))}
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus !== 'Waitlist' && fam.students.map((student) => (
                                        student.studentStatus === 'Waitlist' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={student.studentId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                    ))
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='families-to-watch-col'>
                <h1>Needs New Teacher</h1><p className='families-to-watch-col__count'>{needsCount['MAIN']}</p>
                <div className='families-to-watch-col__scroll-area'>
                {listOfSchools.map(singleSchoolAbbr => (
                        <div key={singleSchoolAbbr} className='families-to-watch__school-flip-down__wrapper' id={`families-to-watch__wrapper__needsnewteacher-${singleSchoolAbbr}`}>
                            <h3 onClick={() => toggleDrawAnimation('needsnewteacher', singleSchoolAbbr)}>{singleSchoolAbbr}</h3>{needsCount[singleSchoolAbbr] > 0 && <p className='families-to-watch-col__count__small'>{needsCount[singleSchoolAbbr]}</p>}
                            <div className='families-to-watch__school-flip-down' id={`families-to-watch__needsnewteacher-${singleSchoolAbbr}`}>
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus === 'Needs New Teacher' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={fam.familyId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                ))}
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus !== 'Needs New Teacher' && fam.students.map((student) => (
                                        student.studentStatus === 'Needs New Teacher' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={student.studentId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                    ))
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='families-to-watch-col'>
                <h1>Taking a Break</h1><p className='families-to-watch-col__count'>{summerCount['MAIN']}</p>
                <div className='families-to-watch-col__scroll-area'>
                    {listOfSchools.map(singleSchoolAbbr => (
                        <div key={singleSchoolAbbr} className='families-to-watch__school-flip-down__wrapper' id={`families-to-watch__wrapper__summerbreak-${singleSchoolAbbr}`}>
                            <h3 onClick={() => toggleDrawAnimation('summerbreak', singleSchoolAbbr)}>{singleSchoolAbbr}</h3>{summerCount[singleSchoolAbbr] > 0 && <p className='families-to-watch-col__count__small'>{summerCount[singleSchoolAbbr]}</p>}
                            <div className='families-to-watch__school-flip-down' id={`families-to-watch__summerbreak-${singleSchoolAbbr}`}>
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus === 'Taking a Break' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={fam.familyId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                ))}
                                {props.familiesToWatch.map(fam => (
                                    fam.familyStatus !== 'Taking a Break' && fam.students.map((student) => (
                                        student.studentStatus === 'Taking a Break' && fam.school === singleSchoolAbbr && <div className='families-to-watch__each-fam' key={student.studentId} onClick={() => props.getFamilyData(fam.familyId)}>{fam.familyName}</div>
                                    ))
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
export default FamiliesToWatch